//defines rev share percentages based on plan tier for ad monetization pages

export const BB4RevShare = {
  Free: {
    revSharePercentage: 70,
    minimumRevShareRequirement: 5,
  },
  Plus: {
    revSharePercentage: 40,
    minimumRevShareRequirement: 50,
  },
  Pro: {
    revSharePercentage: 10,
    minimumRevShareRequirement: 2500,
  },
};

export const BB3RevShare = {
  Free: {
    revSharePercentage: 70,
    minimumRevShareRequirement: 5,
  },
  Plus: {
    revSharePercentage: 40,
    minimumRevShareRequirement: 50,
  },
  Pro: {
    revSharePercentage: 10,
    minimumRevShareRequirement: 2500,
  },
};

export const BB2RevShare = {
  Free: {
    revSharePercentage: 70,
    minimumRevShareRequirement: 5,
  },
  Plus: {
    revSharePercentage: 40,
    minimumRevShareRequirement: 50,
  },
  Pro: {
    revSharePercentage: 10,
    minimumRevShareRequirement: 2500,
  },
};
